module.exports = __webpack_public_path__ + "static/media/img1.ee7ba0d4.png";